/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The UpdatePasswordRequest model module.
 * @module model/UpdatePasswordRequest
 * @version V1
 */
class UpdatePasswordRequest {
    /**
     * Constructs a new <code>UpdatePasswordRequest</code>.
     * @alias module:model/UpdatePasswordRequest
     * @param currentPassword {String} 
     * @param passwordConfirmation {String} 
     * @param password {String} 
     */
    constructor(currentPassword, passwordConfirmation, password) { 
        
        UpdatePasswordRequest.initialize(this, currentPassword, passwordConfirmation, password);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, currentPassword, passwordConfirmation, password) { 
        obj['currentPassword'] = currentPassword;
        obj['passwordConfirmation'] = passwordConfirmation;
        obj['password'] = password;
    }

    /**
     * Constructs a <code>UpdatePasswordRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UpdatePasswordRequest} obj Optional instance to populate.
     * @return {module:model/UpdatePasswordRequest} The populated <code>UpdatePasswordRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UpdatePasswordRequest();

            if (data.hasOwnProperty('currentPassword')) {
                obj['currentPassword'] = ApiClient.convertToType(data['currentPassword'], 'String');
            }
            if (data.hasOwnProperty('passwordConfirmation')) {
                obj['passwordConfirmation'] = ApiClient.convertToType(data['passwordConfirmation'], 'String');
            }
            if (data.hasOwnProperty('password')) {
                obj['password'] = ApiClient.convertToType(data['password'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>UpdatePasswordRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>UpdatePasswordRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of UpdatePasswordRequest.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['currentPassword'] && !(typeof data['currentPassword'] === 'string' || data['currentPassword'] instanceof String)) {
            throw new Error("Expected the field `currentPassword` to be a primitive type in the JSON string but got " + data['currentPassword']);
        }
        // ensure the json data is a string
        if (data['passwordConfirmation'] && !(typeof data['passwordConfirmation'] === 'string' || data['passwordConfirmation'] instanceof String)) {
            throw new Error("Expected the field `passwordConfirmation` to be a primitive type in the JSON string but got " + data['passwordConfirmation']);
        }
        // ensure the json data is a string
        if (data['password'] && !(typeof data['password'] === 'string' || data['password'] instanceof String)) {
            throw new Error("Expected the field `password` to be a primitive type in the JSON string but got " + data['password']);
        }

        return true;
    }


}

UpdatePasswordRequest.RequiredProperties = ["currentPassword", "passwordConfirmation", "password"];

/**
 * @member {String} currentPassword
 */
UpdatePasswordRequest.prototype['currentPassword'] = undefined;

/**
 * @member {String} passwordConfirmation
 */
UpdatePasswordRequest.prototype['passwordConfirmation'] = undefined;

/**
 * @member {String} password
 */
UpdatePasswordRequest.prototype['password'] = undefined;






export default UpdatePasswordRequest;

